export type ExpenseCategory = 
  | 'bol'
  | 'travel'
  | 'fuel'
  | 'settlements'
  | 'meals'
  | 'office'
  | 'miscellaneous'
  | 'statements';

export type TravelSubcategory = 
  | 'uber'
  | 'lyft'
  | 'rental'
  | 'hotel'
  | 'shuttle'
  | 'airfare'
  | 'parking'
  | 'other';

export interface Expense {
  id: string;
  category: ExpenseCategory;
  subcategory?: TravelSubcategory;
  description: string;
  amount?: number;
  date: string;
  month: number; // 1-12
  year: number;
  filename: string;
  fileData: string; // base64 encoded
  fileType: string;
  fileSize: number;
  createdAt: string;
  freightBillNumber?: string; // For BOLs
  isSentToBennett?: boolean; // Track if BOL was emailed
}

export interface DriverSettings {
  driverName: string;
  truckNumber: string;
  driverId: string;
  bennettEmail: string;
  cpaEmail: string;
  reminderDay: number; // Day of month for CPA reminder
}

export interface Stats {
  totalExpenses: number;
  totalAmount: number;
  byCategory: Record<ExpenseCategory, number>;
  byMonth: Record<string, number>;
  storageUsed: number;
  storageUsedFormatted: string;
}

export const CATEGORIES: { value: ExpenseCategory; label: string; icon: string; color: string }[] = [
  { value: 'bol', label: 'Bills of Lading', icon: '📋', color: 'blue' },
  { value: 'travel', label: 'Travel', icon: '✈️', color: 'purple' },
  { value: 'fuel', label: 'Fuel', icon: '⛽', color: 'orange' },
  { value: 'settlements', label: 'Settlements', icon: '💰', color: 'green' },
  { value: 'meals', label: 'Meals', icon: '🍔', color: 'yellow' },
  { value: 'office', label: 'Office Supplies', icon: '📎', color: 'pink' },
  { value: 'miscellaneous', label: 'Miscellaneous', icon: '📦', color: 'gray' },
  { value: 'statements', label: 'Statements', icon: '📄', color: 'teal' },
];

export const TRAVEL_SUBCATEGORIES: { value: TravelSubcategory; label: string; icon: string }[] = [
  { value: 'uber', label: 'Uber', icon: '🚗' },
  { value: 'lyft', label: 'Lyft', icon: '🚕' },
  { value: 'rental', label: 'Rental Car', icon: '🚙' },
  { value: 'hotel', label: 'Hotel', icon: '🏨' },
  { value: 'shuttle', label: 'Shuttle', icon: '🚐' },
  { value: 'airfare', label: 'Airfare', icon: '✈️' },
  { value: 'parking', label: 'Parking', icon: '🅿️' },
  { value: 'other', label: 'Other', icon: '📍' },
];

export const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

export const BENNETT_EMAILS = [
  { code: 'imaging', label: 'Imaging (Default)', email: 'imaging@bennettig.com' },
  { code: 'drd', label: 'DRD', email: 'drd@bennettig.com' },
  { code: 'stx', label: 'STX', email: 'stx@bennettig.com' },
  { code: 'jnc', label: 'JNC', email: 'jnc@bennettig.com' },
  { code: 'mcd', label: 'MCD', email: 'mcd@bennettig.com' },
  { code: 'ptp', label: 'PTP', email: 'ptp@bennettig.com' },
  { code: 'wgo', label: 'WGO', email: 'wgo@bennettig.com' },
  { code: 'mdn', label: 'MDN', email: 'mdn@bennettig.com' },
  { code: 'mca', label: 'MCA', email: 'mca@bennettig.com' },
  { code: 'dcm', label: 'DCM', email: 'dcm@bennettig.com' },
  { code: 'poh', label: 'POH', email: 'poh@bennettig.com' },
];

export const DEFAULT_SETTINGS: DriverSettings = {
  driverName: 'Douglas Sullivan',
  truckNumber: '582826',
  driverId: '130583',
  bennettEmail: 'imaging@bennettig.com',
  cpaEmail: '',
  reminderDay: 7, // Reminder on the 7th for docs due on 8th
};





